export default __webpack_public_path__ + "static/media/unsplash.40adae99.png";